// extracted by mini-css-extract-plugin
module.exports = {"text":"SelectStreets_text__21k9w","city":"SelectStreets_city__1MpjH","name":"SelectStreets_name__3wJ6t"};